import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { DocumentModel } from "../models/document.model";
import { FileItemModel } from "../models/file-item.model";
import { Subject } from 'rxjs';

@Injectable({
    providedIn: "root"
})

export class DocumentService {

    document: DocumentModel = new DocumentModel(0, '', '', '', '', '', '');
    documents: DocumentModel[] = [];
    current_pet_no: number = 0;
    current_client_no: number = 0;
    current_document_id: number = 0;
    current_note:string;
    
    constructor(
        private api: ApiService
    ) {}

    private baseUrl: string = 'document';
    private baseUrl2: string = 'user';

    private notifyDetails = new Subject<void>();
    notifyDetailsObservable = this.notifyDetails.asObservable(); 
    notifyDetailsFunction() { 
        this.notifyDetails.next();
    }

    getDocumentsByParams(pet_no: number,client_no: number,page_number: number, document_name: string,document_type: string,document_note:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getDocumentsByParams?pet_no=${pet_no}&client_no=${client_no}&page_number=${page_number}&document_name=${document_name}&document_type=${document_type}&document_note=${document_note}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.documents = res.data.map((element) => {
                            return new DocumentModel(element.document_id, element.document_name, element.document_type, element.document_data, element.document_note, element.created_by, element.created_on);
                        });
                        resolve(1);
                    } else {
                        this.documents = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //#region upload document
    tempfiles: FileItemModel[] = [];
    SetupDocument(files: FileItemModel,notes: string,pet_no: number,client_no: number, created_by:string,created_on:string) { 
        let documentdata = {
            document_name: files.fileName,
            document_data: files.value,
            document_type: files.fileType, 
        }
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupDocument?note=${notes}&pet_no=${pet_no}&client_no=${client_no}&created_by=${created_by}&created_on=${created_on}`,  documentdata)
                .subscribe((res: any) => {
                    resolve(res.data);
                });
        });
        return promise; 
    }

    deleteDocument(document_id: number,item: DocumentModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deleteDocument?document_id=${document_id}`,item)
                .subscribe((res: any) => {
                    if (res && res.data) {
                      resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getDocument(document_id: number,document_type: string) { 
        let fileURL = '';
        //let promise = new Promise((resolve, reject) => {
            this.api.getFile(`${this.baseUrl}/getDocument?document_id=${document_id}&document_type=${document_type}`)
            .subscribe(blob => {
                fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            });
      //  });
        return fileURL;
    } 

    updateDocument(document_id: number,document_note: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/updateDocument?document_id=${document_id}&document_note=${document_note}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    
}